<template>
    <div>
        <seo-title :content="$t('contact.meta.title')" />
        <seo-description :content="$t('contact.meta.description')" />
        <seo-author content="Deveo ApS" />
        <seo-og-title :content="$t('contact.meta.title')" />
        <seo-og-description :content="$t('contact.meta.description')" />
        <seo-og-image content="/static/images/opengraph/fb_og.png" />
        <section class="cph-bg top-panel">
            <div class="container">
                <br><br>
                <h1 class="test">
                    {{ $t('contact.pageHeader') }}
                </h1>
                <p class="fix-width">
                    {{ $t('contact.pageSubheader') }}
                </p>
                <br><br>
            </div>
        </section>
        <section class="bg-deveo-light">
            <div class="container">
                <div class="row">
                    <div class="col-lg-5">
                        <div class="contactform" v-if="!submitted">
                            <h3 class="contact-header">
                                {{ $t('contact.contactformHeader') }}
                            </h3>
                            <form netlify netlify-honeypot="bot-field" name="contact">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <input type="text"
                                               :placeholder="$t('contact.contactformName')"
                                               class="form-control"
                                               v-model="form.name"
                                               v-validate="'required'"
                                               name="name"
                                        />
                                    </div>
                                    <div class="col-lg-6">
                                        <input type="text"
                                               :placeholder="$t('contact.contactformEmail')"
                                               class="form-control"
                                               v-model="form.email"
                                               v-validate="'required|email'"
                                               name="email"
                                        />
                                    </div>
                                    <div class="col-lg-6">
                                        <input type="text"
                                               :placeholder="$t('contact.contactformPhone')"
                                               class="form-control"
                                               v-model="form.phone"
                                               v-validate="'required|numeric'"
                                               name="phone"
                                        />
                                    </div>
                                    <div class="col-lg-12">
                                        <textarea rows="8"
                                                  type="text"
                                                  :placeholder="$t('contact.contactformMessage')"
                                                  class="form-control"
                                                  v-model="form.message"
                                                  v-validate="'required'"
                                                  name="message"
                                        ></textarea>
                                    </div>
                                    <div class="col-lg-12">
                                        <button class="form-control"
                                                @click.prevent="handleSubmit"
                                                :disabled="!isValidated"
                                        >
                                            <span v-if="isValidated">Send</span>
                                            <span v-else>{{ $t('contact.fillToSend') }}</span>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div class="contactform" v-else>
                            <div v-if="submitSuccess">
                                <h4>{{ $t('contact.formSuccessHeader') }}</h4>
                                <p>
                                    {{ $t('contact.formSuccessText') }}
                                </p>
                            </div>
                            <div v-else>
                                <h4>{{ $t('contact.formErrorHeader') }}</h4>
                                <p>
                                    {{ $t('contact.formErrorText') }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-2"></div>
                    <div class="col-lg-5">
                        <div class="cta-wrapper">
                        <div class="contact-cta">
                            <div class="row">
                                <div class="col-lg-3" align="center">
                                    <div class="icon">
                                        <div class="outer">
                                            <div class="inner">
                                                <span class="ion-android-phone-portrait" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-9">
                                    <h3>
                                        <a href="tel:+4571992895" class="emaillink">
                                            +45 71 99 28 95
                                        </a>
                                    </h3>
                                    <div class="tiny">
                                        {{ $t('contact.phoneHours') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="contact-cta">
                            <div class="row">
                                <div class="col-lg-3" align="center">
                                    <div class="icon">
                                        <div class="outer">
                                            <div class="inner">
                                                <span class="ion-paper-airplane" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-9">
                                    <h3>
                                        <a href="mailto:kontakt@deveo.dk" class="emaillink">
                                            {{ $t('contact.emailText') }}
                                        </a>
                                    </h3>
                                    <div class="tiny">
                                        {{ $t('contact.emailHours') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
    export default {
        data () {
            return {
                submitted: false,
                submitSuccess: false,
                form: {
                    name: '',
                    email: '',
                    phone: '',
                    message: ''
                }
            }
        },
        methods: {
            encode (data) {
                return Object.keys(data)
                    .map(
                        key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`
                    )
                    .join('&')
            },
            handleSubmit () {
                fetch('/', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: this.encode({ 'form-name': 'contact', ...this.form })
                })
                .then(() => {
                    this.submitted = true
                    this.submitSuccess = true
                })
                .catch(() => {
                    this.submitted = true
                })
            }
        },
        computed: {
            isValidated () {
                const form = this.form
                if (this.errors.items.length > 0) {
                    return false
                }
                if (form.name === '') {
                    return false
                }
                if (form.email === '') {
                    return false
                }
                if (form.phone === '') {
                    return false
                }
                if (form.message === '') {
                    return false
                }
                return true
            }
        }
    }
</script>
<style lang="scss">
    .outer-Contact .skew-footer-top{
        background: #F6F9FC;
    }
</style>
<style lang="scss" scoped>
    $main-color: #ff9800;
    .outer, .inner{
        height: 80px;
        width: 80px;
    },
    .inner {
        display: block;
        height: 80px;
        line-height: 80px;
        text-align: center;
        color: #fff;
        font-size: 2em;
    }
    .icon {
        margin-top: -10px;
        top: 4px;
        background: #3A7FFF;
        width: 80px;
        height: 80px;
        border-radius: 50px;
    }
    .main-color {
        color: $main-color;
    }
    .main-bg {
        background: $main-color;
    }
    .main-bg-gradient{
        background: linear-gradient(150deg, rgba(darken($main-color, 10%), 0.85) 15%, rgba(darken($main-color, 10%), 0.85) 70%), url('/static/images/bg.svg') top;
        background-size: cover;
    }
    .cta-wrapper {
        margin-top: -50px;
    }
    @media screen and (max-width:995px){
        .cta-wrapper {
            margin-top: 0px;
        }
    }
    @media screen and (max-width:1199px){
        .icon {
            margin-left: -20px;
        }
    }
    .contact-cta{
        background: #fff;
        border-radius: 4px;
        box-shadow: 0 15px 35px rgba(50,50,93,.1), 0 5px 15px rgba(0,0,0,.07);
        padding: 50px;
        margin: 20px 0;
    }
    @media screen and (max-width:992px){
        .contact-cta h3,
        .contact-cta .tiny{
            text-align: center;
        }
        .contact-cta .icon{
            margin: 0 0 20px 0;
        }
    }
    .contact-cta h1{
        margin: 0;
    }
    .contact-cta h3{
        margin: 0;
        font-weight: 500;
    }
    .contact-cta i.fa{
        opacity: 0.75;
    }
    .tiny{
        margin-top: 10px;
        color: #000;
        font-family: 'Open Sans', sans-serif;
        font-size: 0.8rem;
    }
    input, textarea{
        margin-bottom: 15px;
    }
    .contactform{
        background: #fff;
        padding: 30px;
        border-radius: 4px;
        box-shadow: 0 15px 35px rgba(50, 50, 93, 0.1), 0 5px 15px rgba(0, 0, 0, 0.07);
        margin-top: -100px;
        font-family: 'Open Sans', sans-serif;
        .contact-header, button {
            font-family: 'Poppins', sans-serif;
            font-weight: 400;
        }
    }
    button{
        background: darken(#3A7FFF, 0%);
        color: #fff;
    }
    button:not([disabled]):hover{
        /* background: darken(#3A7FFF, 5%); */
        cursor: pointer;
    }
    button:disabled span{
        color: initial;
        opacity: .5;
    }
    .contactform p, .contactform h4{
        margin: 5px;
        text-align: center;
    }
    input[aria-invalid=true], textarea[aria-invalid=true]{
        border: 1px solid #F44336;
    }
    .contactform h3{
        margin-bottom: 30px;
    }
    .cf-section{
        background: linear-gradient(150deg, rgba(33, 37, 41, 0.85) 15%, rgba(33, 37, 41, 0.85) 70%), url("/static/img/contact-min.jpeg") center top;
        background-size: cover;
        padding: 120px 0px;
    }
    .emaillink:hover{
        text-decoration: none;
    }
</style>



// WEBPACK FOOTER //
// index.vue?1e20930d